import moment from 'moment'

/**
 * Computes the "yesterday BD-day" claim window expressed in GMT+8 wall-clock time
 * (the database/server timezone).
 *
 * Bangladesh (BD) is GMT+6 and the back-office DB runs in GMT+8, so a BD day
 * runs from GMT+8 02:00 to next-day GMT+8 02:00. The Bhaggo 24h rebate-claim
 * window shows only yesterday's BD-day rebate.
 *
 * Example: if "now" in GMT+8 is 2026-05-29 10:00, this returns
 *   { startTime: '2026-05-28 02:00:00', endTime: '2026-05-29 01:59:59' }
 *
 * @returns {{ startTime: string, endTime: string }} formatted YYYY-MM-DD HH:mm:ss
 */
export function getYesterdayBdRangeInGmt8() {
  // Anchor "now" in GMT+8 regardless of the client's local timezone.
  const nowGmt8 = moment().utcOffset(8 * 60)

  // BD-day boundary expressed in GMT+8 = 02:00.
  // If we are still before today's 02:00 GMT+8, we are technically inside
  // yesterday's BD-day, so shift one extra day back.
  let todayBoundary = nowGmt8.clone().startOf('day').add(2, 'hours')
  if (nowGmt8.isBefore(todayBoundary)) {
    todayBoundary = todayBoundary.subtract(1, 'day')
  }
  const startBoundary = todayBoundary.clone().subtract(1, 'day')

  return {
    startTime: startBoundary.format('YYYY-MM-DD HH:mm:ss'),
    endTime: todayBoundary.clone().subtract(1, 'second').format('YYYY-MM-DD HH:mm:ss')
  }
}

export default { getYesterdayBdRangeInGmt8 }
